import mixpanel from 'mixpanel-browser';
import config from 'shared/config/config.js';

mixpanel.init('c437e3d502ae959b14e28c80437b5446');
mixpanel.set_config({debug: true});

let enabled = config.env === 'production';

let actions = {
  identify: (id) => {
    if (enabled) mixpanel.identify(id);
  },
  alias: (id) => {
    if (enabled) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (enabled) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (enabled) mixpanel.people.set(props);
    }
  }
};

export let Mixpanel = actions;
